import { GroupSessionsFilterPanelFormBean } from './filters/GroupSessionsFilterPanel.types';

export const GROUP_SESSIONS_FILTER_PANEL_DEFAULT_VALUES: GroupSessionsFilterPanelFormBean = {
   healthcareProviderLocations: [],
   practitioners: [],
   statuses: [],
   services: [],
   scheduleDayOfWeek: null,
   scheduleTimesOfDay: [],
   groupTypes: ['CLOSED'],
   occupancy: null,
   issue: null,
};
